import { render } from "./gaimi.vue?vue&type=template&id=f2a5fc44&scoped=true"
import script from "./gaimi.vue?vue&type=script&lang=js"
export * from "./gaimi.vue?vue&type=script&lang=js"

import "./gaimi.vue?vue&type=style&index=0&id=f2a5fc44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2a5fc44"]])

export default __exports__